/**
 * QuickOnline-aligned labels — keep in sync with
 * backend/shipment/constants/quickstat_booking_form_options.py
 */

export const QUICKSTAT_COMMODITY_TEMPERATURE_LABELS: readonly string[] = [
  '-30c to -50c',
  '-15c to -25c',
  '+2c to +8c',
  '+15c to +25c',
  'Ambient (+2c to +30c)',
  'Ambient (uncontrolled)',
  'Cryoshipper',
  'Dry Ice (-80c)',
  'No Temp Requirement',
  'Wet Ice +2 to +8c',
];

export const QUICKSTAT_PACKAGING_LABELS: readonly string[] = [
  'Accutemp',
  'Biotherm BT30 +15 TO +25',
  'Biotherm BT45 Dry Ice',
  'Biotherm BT80 Dry Ice',
  'CSAFEGLOBAL',
  'Chilltherm Summer (+2 to +8c / 96 hr)',
  'Chilltherm Winter (+2 to +8c / 96 hr)',
  'Credo Series 4 (Refrigerated +2 to +8c)',
  'Credo Series 20M (Frozen -15 to -25c)',
  'Credo Series 22 (Ambient +15 to +25c)',
  'Credo Series 50M (Frozen -40 to -50c)',
  'Cryoport CXHV3 High Volume Dry Shipper',
  'Customer Supplied Packaging',
  'Dry Shipper/LN2',
  'Envirotainer',
  'ISC Carton (+2c - +25c)',
  'KryoTrans (+2 TO +8)',
  'KryoTrans (+15 TO +25)',
  'KryoTrans (-25 TO -15)',
  'KryoTrans (-80 TO -20)',
  'NANOCOOLER (+2C to +8C)',
  'PBMMI CT-250 HIGH VOLUME DRY SHIPPER',
  'Quick (QS1) Dry Ice Shipper',
  'Quick (QS2) Dry Ice Shipper',
  'Quick (QS3) Dry Ice Shipper',
  'Quick (QSXL) Dry Ice Shipper',
  'Quick STAT Packaging',
  'SAVSU EVO',
  'VA-Q-ONE 21 (Frozen -15 to -25c)',
  'VA-Q-PROOF (-80 to -85)',
  'VA-Q-TAINER (Ambient +15 to +25c)',
  'VA-Q-TAINER (Frozen -15 to -25c)',
  'VA-Q-TAINER (Frozen -30 to -80c)',
  'VA-Q-TAINER (Refrigerated +2 to +8c)',
  'va-Q-proof 5 (Refrigerated +2 to +8c)',
  'va-Q-proof 21(Frozen -15 to -25c)',
  'va-Q-proof 22 (Ambient +15 to +25c)',
];

/** Map template / pasted values to a canonical allowlist label when possible. */
export function matchQuickstatOptionLabel(
  raw: string | null | undefined,
  allowlist: readonly string[]
): string | undefined {
  const t = String(raw ?? '').trim();
  if (!t) return undefined;
  if (allowlist.includes(t)) return t;
  const lower = t.toLowerCase();
  const hit = allowlist.find((x) => x.toLowerCase() === lower);
  return hit;
}

export const commodityTemperatureSelectOptions =
  QUICKSTAT_COMMODITY_TEMPERATURE_LABELS.map((v) => ({
    label: v,
    value: v,
  }));

export const packagingSelectOptions = QUICKSTAT_PACKAGING_LABELS.map((v) => ({
  label: v,
  value: v,
}));
